<template>
  <v-card class="elevation-0">
    <v-tabs
      v-model="tab"
      height="50px"
      background-color="primary"
      dark
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#mission-applications">
        <v-icon>mdi-map-search-outline</v-icon>
        {{ $t("mission.applications") }}
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="'mission-applications'" :value="'mission-applications'">
        <application-tab
          v-if="tab == 'mission-applications'"
          :mission="mission"
          @application-data="forwardApplicationData"
        ></application-tab>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApplicationsTab from "@/components/Mission/ApplicationsTab";

export default {
  name: "ClientTabs",
  components: {
    "application-tab": ApplicationsTab,
  },
  props: {
    mission: [Object],
  },
  async mounted() {

  },
  data() {
    return {
      tab: null,
      text: "",
    };
  },
  computed: {
    
  },
  watch: {

  },
  methods: {
    forwardApplicationData(payload){
        this.$emit("application-data", payload);
    }
  },
};
</script>

<style scoped></style>
